<template>
  <header class="header-global">
    <base-nav class="navbar-main" transparent type effect="light" expand>
      <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
        <span style="font-weight:bold">
          <font size="3">
            <i>Robots, jobs, and resilience</i>
          </font>
        </span>
        <!--img src="img/brand/white.png" alt="logo" style="height:45px" /-->
      </router-link>

      <div class="row" slot="content-header" slot-scope="{closeMenu}">
        <div class="col-6 collapse-brand">
          <!-- <a href="https://demos.creative-tim.com/vue-argon-design-system/documentation/">
            <img src="img/brand/blue.png" />
          </a>-->
        </div>
        <div class="col-6 collapse-close">
          <close-button @click="closeMenu"></close-button>
        </div>
      </div>

      <!-- <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
        <base-dropdown tag="li" class="nav-item">
          <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">
            <i class="ni ni-collection d-lg-none"></i>
            <span class="nav-link-inner--text">Examples</span>
          </a>
          <router-link to="/landing" class="dropdown-item">Landing</router-link>
          <router-link to="/profile" class="dropdown-item">Profile</router-link>
          <router-link to="/login" class="dropdown-item">Login</router-link>
          <router-link to="/register" class="dropdown-item">Register</router-link>
        </base-dropdown>
      </ul>-->
      <ul class="navbar-nav align-items-lg-center ml-lg-auto">
        <base-dropdown class="nav-item" menu-classes="dropdown-menu-xl">
          <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">
            <i class="ni ni-ui-04 d-lg-none"></i>
            <span class="nav-link-inner--text">Documentation</span>
          </a>
          <div class="dropdown-menu-inner">
            <a href="/resiliencetorobots/#/doc/index" class="media d-flex align-items-center">
              <div class="icon icon-shape bg-gradient-primary rounded-circle text-white">
                <i class="ni ni-spaceship"></i>
              </div>
              <div class="media-body ml-3">
                <h6 class="heading text-primary mb-md-1">Automation risk index </h6>
                <!--p
                  class="description d-none d-md-inline-block mb-0"
                >Know more about the calculation of robotizability indexs</p-->
              </div>
            </a>
            <a href="/resiliencetorobots/#/doc/res-index" class="media d-flex align-items-center">
              <div class="icon icon-shape bg-gradient-warning rounded-circle text-white">
                <i class="ni ni-ui-04"></i>
              </div>
              <div class="media-body ml-3">
                <h5 class="heading text-warning mb-md-1">Resilience index</h5>
                <!--p
                  class="description d-none d-md-inline-block mb-0"
                >Know more about the calculation of resilience jobs identification</p-->
              </div>
            </a>
          </div>
        </base-dropdown>
        <!-- TODO: PUT LINK TO DATA WHEN PAPER IS ACCEPTED -->
        <!-- <li class="nav-item d-lg-block ml-lg-4">
          <a href="https://github.com/lis-epfl/jobrisk" rel="noopener" class="nav-link">
            <span class="btn-inner--icon">
              <i class="fa fa-cloud-download mr-2"></i>
            </span>
            <span class="nav-link-inner--text">Data</span>
          </a>
        </li> -->
        <!-- <li class="nav-item d-lg-block ml-lg-4">
          <a href="/resiliencetorobots/#/doc/contribute" rel="noopener" class="nav-link">
            <span class="nav-link-inner--text">Contribute</span>
          </a>
        </li> -->
        <li class="nav-item d-lg-block ml-lg-4">
          <a href="/resiliencetorobots/#/doc/contacts" rel="noopener" class="nav-link">
            <!-- <span class="btn-inner--icon">
              <i class="fa fa-cloud-download mr-2"></i>
            </span>-->
            <span class="nav-link-inner--text">Contacts and Funding</span>
          </a>
        </li>
      </ul>
    </base-nav>
  </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";
export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown
  }
};
</script>
<style>
</style>
